// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"cf6fb02b","381":"889e49c3","400":"33686acd"}[chunkId] + ".chunk.js";
};